/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Empty_ShortcutInputs */

const en_us2_search_preview_empty_shortcut = /** @type {(inputs: Search_Preview_Empty_ShortcutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opens search from any screen.`)
};

const pt_br2_search_preview_empty_shortcut = /** @type {(inputs: Search_Preview_Empty_ShortcutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abre a busca em qualquer tela.`)
};

const es_419_search_preview_empty_shortcut = /** @type {(inputs: Search_Preview_Empty_ShortcutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abre la búsqueda desde cualquier pantalla.`)
};

const pt_pt2_search_preview_empty_shortcut = /** @type {(inputs: Search_Preview_Empty_ShortcutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abre a pesquisa em qualquer ecrã.`)
};

const fr_fr2_search_preview_empty_shortcut = /** @type {(inputs: Search_Preview_Empty_ShortcutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ouvre la recherche depuis n'importe quel écran.`)
};

const de_de2_search_preview_empty_shortcut = /** @type {(inputs: Search_Preview_Empty_ShortcutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`öffnet die Suche auf jedem Bildschirm.`)
};

const it_it2_search_preview_empty_shortcut = /** @type {(inputs: Search_Preview_Empty_ShortcutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`apre la ricerca da qualsiasi schermata.`)
};

/**
* | output |
* | --- |
* | "opens search from any screen." |
*
* @param {Search_Preview_Empty_ShortcutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_empty_shortcut = /** @type {((inputs?: Search_Preview_Empty_ShortcutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Empty_ShortcutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_empty_shortcut(inputs)
	if (locale === "es-419") return es_419_search_preview_empty_shortcut(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_empty_shortcut(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_empty_shortcut(inputs)
	if (locale === "de-DE") return de_de2_search_preview_empty_shortcut(inputs)
	if (locale === "it-IT") return it_it2_search_preview_empty_shortcut(inputs)
	return en_us2_search_preview_empty_shortcut(inputs)
});
export { search_preview_empty_shortcut as "search.preview_empty_shortcut" }